import { FunctionComponent, useCallback, useContext, useEffect, useRef, useState } from "react";
import { makeRipple } from "@/react/core/ripple-utils";
import { KioskOrderMode, setKioskOrderMode } from "../../../../../src/react/KioskOrderView/KioskOrderView";
import LightCancelOrderPopupPlugin from "./Popup/LightCancelOrderPopupPlugin";
import PortalPopup from "@/react/core/PortalPopup.tsx";
import { PosScreen, router } from "../../../../../src/pos/PosRouter";
import CartProductItem from "./CartProductItem";
import { LL3 } from "../../../../../src/react/core/I18nCurrency";
import { toast } from "react-toastify";
import { ItemFactoryContext } from "../../../../../src/react/PaymentView/OrderItemsFactory2";
import { LL0 } from "../../../../../src/react/core/I18nService";
import { signal } from "@/react/core/reactive.ts";

export type CartType = {
  className?: string;
};

export const [footerHeight, setFooterHeight] = signal(311)

const Cart: FunctionComponent<CartType> = ({ className = "" }) => {
  const { order0 } = useContext(ItemFactoryContext);

  const [isOpenCancelOrderPopup, setIsOpenCancelOrderPopup] = useState(false);

  const openCancelOrderPopup = useCallback(() => {
    setIsOpenCancelOrderPopup(true);
  }, [])

  const closeOpenCancelOrderPopup = useCallback(() => {
    setIsOpenCancelOrderPopup(false);
  }, [])

  const countItems = order0?.()?.items?.filter(item => item.quantity > 0).length

  const footerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (footerRef.current) {
        setFooterHeight(footerRef.current.offsetHeight);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <div
        ref={footerRef}
        className={`absolute bottom-0 left-0 right-0 z-[99] self-stretch flex flex-row items-center justify-start p-[16px] gap-[10px] bg-[url('/public/cart@3x.png')] bg-cover bg-no-repeat bg-[top] text-left text-[20px] text-[#333] font-['Libre_Caslon_Text'] md:h-auto sm:h-auto sm:flex-row sm:gap-[8px] sm:p-[8px] sm:box-border mq514:h-auto mq514:gap-[8px] mq514:p-[8px] mq514:box-border mq3030:gap-[40px] mq3030:p-[40px] mq3030:box-border mq4024:gap-[50px] mq4024:p-[50px] mq4024:box-border ${className}`}
      >
        {countItems > 0 && <div
          className="no-scrollbar h-[280px] self-stretch flex-[0.9274] rounded-[6px] bg-[#fff] overflow-y-auto flex flex-col items-center justify-start pt-[12px] px-[12px] pb-[0px] md:hidden  mq1998:flex mq1998:flex-1 mq2568:flex mq2568:flex-1 mq3030:flex mq3030:flex-1 mq3030:gap-[40px] mq3030:p-[40px] mq3030:box-border mq3502:flex mq3502:flex-1 mq4024:flex mq4024:flex-1 mq4024:gap-[50px] mq4024:p-[50px] mq4024:box-border">
          {order0?.()?.items?.filter(item => item.quantity > 0).map((item, index) => (
            <div key={index} className="w-full flex flex-col">
              <CartProductItem item={item} />
              <div className="w-full h-[2px] bg-[#ccc] my-2.5" />
            </div>
          ))}
        </div>
        }
      {countItems < 1 &&
        <div className="self-stretch flex-1 rounded-[6px] [background:linear-gradient(180deg,_#373737,_#262626)] flex flex-col items-center justify-center py-[4px] px-[2px] gap-[12px] text-center text-[22px] text-[#fff] mq1998:p-[8px] mq1998:box-border mq3502:py-[16px] mq3502:px-[8px] mq3502:box-border">
          <div className="self-stretch flex flex-col items-center justify-center gap-[8px]">
            <div className="self-stretch relative font-semibold lg:text-[24px] md:text-[20px] sm:text-[15px] mq1480:text-[40px] mq1998:text-[40px] mq2568:text-[54px] mq3030:text-[60px] mq3502:text-[64px]">
              {LL0().kiosk.EmptyCart()}
            </div>
            <div className="self-stretch relative text-[16px] lg:text-[16px] md:text-[14px] sm:text-[11px] mq1480:text-[24px] mq1998:text-[30px] mq2568:text-[35px] mq3030:text-[44px] mq3502:text-[48px]">
              {LL0().kiosk.NotificationCartEmpty()}
            </div>
          </div>
          <img
            className="w-[120px] relative h-[120px] object-cover lg:w-[140px] lg:h-[140px] sm:w-[66px] sm:h-[66px] mq1480:w-[200px] mq1480:h-[200px] mq2568:w-[240px] mq2568:h-[240px] mq3030:w-[300px] mq3030:h-[300px] mq3502:w-[300px] mq3502:h-[300px]"
            alt=""
            src="/imagesempty-cart@2x.png"
          />
        </div>
      }
        <div
          className="flex-1 rounded-[6px] flex flex-col items-start justify-start p-[16px] box-border gap-[20px] bg-[url('/public/total@3x.png')] bg-cover bg-no-repeat bg-[top] max-w-[none] lg:h-auto lg:max-w-[none] md:h-auto md:gap-[16px] md:max-w-[none] sm:flex-1 sm:gap-[8px] sm:max-w-[none] mq514:gap-[8px] mq514:p-[8px] mq514:box-border mq514:max-w-[none] mq1480:flex-1 mq1480:max-w-[none] mq1998:flex-1 mq1998:max-w-[650px] mq2568:flex-1 mq2568:gap-[100px] mq2568:max-w-[800px] mq3030:flex-1 mq3030:p-[40px] mq3030:box-border mq3030:max-w-[950px] mq3502:flex-1 mq3502:max-w-[1200px] mq4024:p-[50px] mq4024:box-border">
          <div
            className="self-stretch flex flex-col items-start justify-start gap-[20px] lg:flex-1 md:gap-[16px] sm:gap-[8px] mq514:gap-[8px]">
            <div className="self-stretch flex flex-row items-center justify-start gap-[8px]">
              <img
                className="w-[32px] relative h-[32px] object-cover md:w-[24px] md:h-[24px] sm:w-[20px] sm:h-[20px] mq514:w-[26px] mq514:h-[26px] mq1480:w-[40px] mq1480:h-[40px] mq1998:w-[50px] mq1998:h-[50px] mq2568:w-[60px] mq2568:h-[60px] mq3030:w-[70px] mq3030:h-[70px] mq3502:w-[80px] mq3502:h-[80px]"
                alt=""
                src="/iconcart@2x.png"
              />
              <b
                className="flex-1 relative lg:text-[20px] md:text-[16px] mq514:text-[14px] mq1480:text-[24px] mq1998:text-[32px] mq2568:text-[36px] mq3030:text-[40px] mq3502:text-[48px]">
                {LL0().kiosk.YourOrder()}
              </b>
              <b
                className="relative text-[24px] text-[#ea9a00] text-center lg:text-[20px] md:text-[16px] mq514:text-[14px] mq1480:text-[24px] mq1998:text-[32px] mq2568:text-[36px] mq3030:text-[40px] mq3502:text-[48px]">
                {countItems} {LL0().order.items()}
              </b>
            </div>
            <div
              className="self-stretch flex flex-col items-start justify-start gap-[12px] text-center mq514:gap-[8px] mq2568:gap-[24px]">
              <img
                className="self-stretch relative max-w-full overflow-hidden max-h-full"
                alt=""
                src="/divider.svg"
              />
              <div className="self-stretch flex flex-row items-center justify-between">
                <b
                  className="relative md:text-[16px] sm:text-[12px] mq514:text-[14px] mq1480:text-[24px] mq1998:text-[28px] mq2568:text-[32px] mq3030:text-[40px] mq3502:text-[48px]">
                  {LL0().order.total()}
                </b>
                <b
                  className="relative text-[26px] text-[#00c520] md:text-[20px] mq514:text-[15px] mq1480:text-[36px] mq1998:text-[44px] mq2568:text-[52px] mq3030:text-[60px] mq3502:text-[68px]">
                  {LL3().format.currency(order0?.()?.vSum)}
                </b>
              </div>
            </div>
          </div>
          <div className="self-stretch flex flex-col items-start justify-start gap-[12px] text-center text-[#fff]">
            <div className="self-stretch flex flex-col items-start justify-start md:gap-[8px]"
                 ref={makeRipple}
                 onClick={() => {
                   if (countItems > 0) {
                    setKioskOrderMode(KioskOrderMode.CART_ORDER)
                   } else {
                     toast.error("Please select an item from the list above")
                   }
                 }}
            >
              <div
                className="self-stretch [backdrop-filter:blur(20px)] rounded-[8px] [background:linear-gradient(180deg,_#ffb08f,_#fd7840_40.5%)] border-[#ffc38b] border-[2px] border-solid flex flex-row items-center justify-center py-[16px] px-[0px] md:pt-[8px] md:pb-[8px] md:box-border sm:pt-[8px] sm:pb-[8px] sm:box-border mq514:h-[32px] mq514:items-center mq514:justify-center mq514:pt-[4px] mq514:pb-[4px] mq514:box-border">
                <div
                  className="flex-1 relative font-semibold md:text-[16px] sm:text-[14px] mq514:text-[12px] mq1480:text-[24px] mq1998:text-[28px] mq2568:text-[32px] mq3030:text-[40px] mq3502:text-[48px]">
                  {LL0().kiosk.ViewOrder()}
                </div>
              </div>
            </div>
            <div
              className="self-stretch [backdrop-filter:blur(12px)] rounded-[8px] bg-[rgba(255,255,255,0.2)] border-[#747980] border-[1.5px] border-solid flex flex-row items-center justify-center py-[16px] px-[0px] text-[#747980] md:pt-[8px] md:pb-[8px] md:box-border"
              ref={makeRipple}
              onClick={openCancelOrderPopup}
            >
              <div
                className="flex-1 relative font-semibold md:text-[16px] sm:text-[14px] mq1480:text-[24px] mq1998:text-[28px] mq2568:text-[32px] mq3030:text-[40px] mq3502:text-[48px]">
                {LL0().kiosk.CancelOrder()}
              </div>
            </div>
          </div>
        </div>
        {/*<div*/}
        {/*  className="self-stretch flex-[0.8864] rounded-[6px] [background:linear-gradient(180deg,_#ffb08f,_#fd7840)] flex flex-col items-start justify-start py-[16px] px-[12px] box-border gap-[12px] max-w-[180px] text-center text-[15px] text-[#fff] sm:gap-[8px] sm:max-w-[150px] mq514:p-[8px] mq514:box-border mq514:max-w-[144px] mq1480:max-w-[240px] mq1998:max-w-[260px] mq2568:gap-[20px] mq2568:max-w-[280px] mq3030:gap-[40px] mq3030:p-[40px] mq3030:box-border mq3030:max-w-[400px] mq3502:max-w-[500px] mq4024:max-w-[600px]">*/}
        {/*  <div className="self-stretch flex-1 flex flex-row items-center justify-center">*/}
        {/*    <img*/}
        {/*      className="w-[94px] relative h-[94px] object-cover lg:w-[86px] lg:h-[86px] md:w-[72px] md:h-[72px] sm:w-[64px] sm:h-[64px] mq514:w-[48px] mq514:h-[48px] mq2568:w-[120px] mq2568:h-[120px] mq3030:w-[150px] mq3030:h-[150px] mq3502:w-[180px] mq3502:h-[180px]"*/}
        {/*      alt=""*/}
        {/*      src="/iconqr-code@2x.png"*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*  <div*/}
        {/*    className="self-stretch relative leading-[24px] font-semibold lg:text-[14px] md:font-medium md:font-['Libre_Caslon_Text'] md:text-[13px] sm:font-['Libre_Caslon_Text'] sm:text-[12px] mq514:font-medium mq514:font-['Libre_Caslon_Text'] mq514:text-[11px] mq1998:text-[22px] mq3030:text-[30px] mq3502:text-[34px] mq4024:text-[40px]">*/}
        {/*    <p className="m-[0px]">Have a promo code?</p>*/}
        {/*    <p className="m-[0px]">Scan to redeem!</p>*/}
        {/*  </div>*/}
        {/*  <div*/}
        {/*    className="self-stretch [backdrop-filter:blur(20px)] rounded-[8px] border-[#fff] border-[2px] border-solid box-border h-[44px] flex flex-row items-center justify-end py-[16px] px-[10px] relative text-[16px] lg:h-[40px] md:h-[36px] md:pt-[8px] md:pb-[8px] md:box-border sm:pt-[8px] sm:pb-[8px] sm:box-border mq514:h-[32px] mq514:items-center mq514:justify-center mq514:pt-[4px] mq514:pb-[4px] mq514:box-border mq1998:h-[44px] mq2568:h-[50px] mq3030:h-[80px] mq4024:h-[88px]">*/}
        {/*    <img*/}
        {/*      className="w-[22px] relative h-[22px] object-contain z-[0]"*/}
        {/*      alt=""*/}
        {/*      src="/rectangle-1@2x.png"*/}
        {/*    />*/}
        {/*    <div*/}
        {/*      className="w-[39px] absolute !m-[0] top-[calc(50%_-_10px)] left-[calc(50%_-_20px)] font-semibold inline-block z-[1] md:text-[16px] sm:text-[13px] mq514:text-[12px] mq1480:text-[20px] mq1998:text-[22px] mq2568:text-[28px] mq3030:text-[40px] mq3502:text-[48px]">*/}
        {/*      Scan*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
      {isOpenCancelOrderPopup && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeOpenCancelOrderPopup}
        >
          <LightCancelOrderPopupPlugin
            onClose={closeOpenCancelOrderPopup}
            onConfirm={() => {
              router.screen = PosScreen.KIOSK_START_SCREEN
            }}
          />
        </PortalPopup>
      )}
    </>
  );
};

export default Cart;
